import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseService } from '../shared/services/base.service';
import { Page } from '../models/page.model';
import { Usuario } from '../models/usuario.model';

@Injectable({
    providedIn: 'root'
})

export class UsuarioService extends BaseService<Usuario> {
    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/usuario`, injector);

    }

    GetAllIncludeNotActive(): Observable<Page<Usuario>> {
        return this.http.get<Page<Usuario>>(`${environment.API_PRICE}/usuario/GetAll`)
    }

    getById(id: number) {
        return this.http.get<Usuario>(`${environment.API_PRICE}/usuario/${id}`);
    }

    add(usuario: Usuario): Observable<Usuario> {
        return this.http.post<Usuario>(`${environment.API_PRICE}/usuario`, usuario);
    }

    edit(usuario: Usuario): Observable<Usuario> {
        return this.http.put<Usuario>(`${environment.API_PRICE}/usuario/${usuario.id}`, usuario);
    }

    activateOrDeactivate(id: Number, isChecked: Boolean): Observable<void> {
        return this.http.patch<void>(
            `${environment.API_PRICE}/usuario/ActivateOrDeactivate/${id}`, 
            isChecked
        );
    }
}
